import { Component } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-downloads-view',
  imports: [],
  template: ``,
  styles: ``,
})
export class DownloadsViewComponent extends BaseComponent {}
